function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CapitalOne = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsxs("g", {
    id: "Brand=Cap1, Size=40px",
    clipPath: "url(#clip0_6848_4107)",
    children: [/*#__PURE__*/_jsx("path", {
      id: "Vector",
      fill: "#fff",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }), /*#__PURE__*/_jsxs("g", {
      id: "Mask group",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "mask0_6848_4107",
        width: "40",
        height: "40",
        x: "0",
        y: "0",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group",
          children: /*#__PURE__*/_jsx("path", {
            id: "Vector_2",
            fill: "#fff",
            d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#mask0_6848_4107)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Group_2",
          children: /*#__PURE__*/_jsx("path", {
            id: "Vector_3",
            fill: "#CC2427",
            d: "M-55.953 18.446a264.85 264.85 0 0 1 2.264-.397c9.148-1.729 7.82-3.16 42.337-7.21 22.178-2.894 44.706-2.577 47.547 3.68 4.428 9.755-35.85 31.309-57.362 42.025 29.263-18.466 42.7-29.57 38.282-36.626-6.355-10.149-48.469-5.687-70.804-1.87-.688.131-1.436.263-2.264.398Z"
          })
        })
      })]
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_6848_4107",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h40v40H0z"
      })
    })
  })]
}));
CapitalOne.displayName = 'CapitalOne';
//# sourceMappingURL=CapitalOne.js.map